<template>
  <div class="row">
    <bita-input
      type="text"
      name="name"
      label="جستجو (نام)"
      validation-container-class="col-lg-4"
      input-class="form-control"
      v-model.lazy="filters.search"
      @keyup.enter.prevent="loadData"
    />
    <bita-input
      type="text"
      name="name"
      label="جستجو (تعداد یا قیمت)"
      validation-container-class="col-lg-4"
      input-class="form-control"
      v-model.lazy="filters.count_price"
      @keyup.enter.prevent="loadData"
    />
    <div class="col-lg-4">
      <a class="margin-top btn btn-success" @click="loadData()">
        جستجو
      </a>
      <a
        class="margin-top margin-right btn btn-warning"
        @click="resetFilters()"
      >
        پاک سازی
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { filters: {} };
  },
  methods: {
    loadData() {
      this.$emit("search", this.filters);
    },
    resetFilters() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>

<style></style>
